import {useEffect} from 'react';
import eventBus, {FLEX_BUILDER_DELETE} from '@/eventBus';

const pendingMap = new Map<string, { timeout: ReturnType<typeof setTimeout>, token: string }>();

function generateId() {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/**
 * 处理 builder 被删除场景
 * useEffect unmount 后 1 秒内，如果 builderId 没有被重新设置，则认为 builder 被删除
 * @param builderId
 * @param readonly 是否只读，只读情况下不处理 builder 删除场景（块引用场景）
 * @param isCopyScene 复制场景，不处理 builder 删除场景
 */
export function useBuilderEffect(builderId: string, readonly: boolean, isCopyScene: boolean = false) {
    useEffect(() => {
        if (builderId && !readonly && !isCopyScene) {
            const existing = pendingMap.get(builderId);
            if (existing) {
                clearTimeout(existing.timeout);
                pendingMap.delete(builderId);
            }
        }

        const token = generateId();

        return () => {
            if (builderId && !readonly && !isCopyScene) {
                const timeout = setTimeout(() => {
                    const current = pendingMap.get(builderId);
                    if (current?.token === token) {
                        eventBus.emit(FLEX_BUILDER_DELETE, builderId);
                        pendingMap.delete(builderId);
                    }
                }, 1000);

                pendingMap.set(builderId, {timeout, token});
            }
        };
    }, [builderId, isCopyScene, readonly]);
}
